module.exports = "img/25.9839cf.webp";